import { useProfileStore } from "../../../../stores/UserStore";
import { Alert, Button, Group, Text, ThemeIcon } from "@mantine/core";
import { IconExclamationCircle } from "@tabler/icons-react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { Link } from "react-router-dom";

const PaymentError = (props) => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);

  if (profile?.subscriptions?.last_payment_succeeded === false) {
    if (
      profile?.subscriptions?.subscription_id &&
      profile?.subscriptions?.last_payment_error_status !== "requires_action" &&
      profile?.subscriptions?.last_payment_error_status !== "canceled"
    ) {
      return (
        <Alert
          pos={"absolute"}
          top={96}
          right={32}
          w={250}
          color="red"
          radius={"md"}
          {...props}
        >
          <Group mb={8}>
            <ThemeIcon color="red">
              <IconExclamationCircle />
            </ThemeIcon>
            <Text c={"red"} fw={600}>
              {lang.pricing.free.payment_failed}
            </Text>
          </Group>
          {lang.pricing.free.ended_payment_error}
          <Button mt={16} component={Link} to={"/settings/subscription"}>
            {lang.pricing.free.verify_subscription}
          </Button>
        </Alert>
      );
    }
    if (
      profile?.subscriptions?.subscription_id &&
      profile?.subscriptions?.last_payment_error_status === "requires_action"
    ) {
      return (
        <Alert
          pos={"absolute"}
          top={96}
          right={32}
          w={250}
          color="red"
          bg={"#ffeeee"}
          radius={"md"}
          style={{ zIndex: 10 }}
          {...props}
        >
          <Group mb={8}>
            <Text c={"red"} fw={600}>
              {lang.pricing.free.payment_verification_required}
            </Text>
          </Group>
          {lang.pricing.free.payment_required_action}
          <Button
            mt={16}
            component={Link}
            to={profile?.subscriptions?.last_payment_error_details?.action_url}
          >
            {lang.pricing.free.verify_payment}
          </Button>
        </Alert>
      );
    }
  }

  return;
};

export default PaymentError;
